import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(({ spacing }: Theme) => ({
  container: {
    display: 'flex',
    flex: '1 1 0',
    flexDirection: 'column',
    // gap: spacing(2),
  },
  line: {
    display: 'flex',
    minHeight: '56px',
    gap: spacing(2),
    justifyItems: 'center'
  },
}));

export default useStyles;
